const findCmsTags = (obj, conditions = []) => {
  const results = [];
  if (obj == null) {
    return results;
  }
  let conditionsCopy = [...conditions];
  if (typeof obj === "object" && "conditions" in obj) {
    const objWithConditions = obj;
    if (objWithConditions.conditions) {
      conditionsCopy = [...conditionsCopy, objWithConditions.conditions];
    }
  }
  if (typeof obj === "object" && "isCmsContent" in obj && obj.isCmsContent === true && "contentType" in obj && "identifier" in obj) {
    const cmsTag = obj;
    if (cmsTag.contentType && cmsTag.identifier) {
      results.push({
        contentType: cmsTag.contentType,
        identifier: cmsTag.identifier,
        conditions: conditionsCopy
      });
    }
  }
  if (Array.isArray(obj)) {
    obj.forEach((item) => {
      results.push(...findCmsTags(item, conditionsCopy));
    });
  } else if (typeof obj === "object") {
    for (const [, value] of Object.entries(obj)) {
      results.push(...findCmsTags(value, conditionsCopy));
    }
  }
  return results;
};
const findAllCmsTags = (config) => {
  const cmsTags = findCmsTags(config);
  const cmsTagMap = {};
  for (const tag of cmsTags) {
    if (!cmsTagMap[tag.contentType]) {
      cmsTagMap[tag.contentType] = [];
    }
    if (!cmsTagMap[tag.contentType].some((t) => t.identifier === tag.identifier)) {
      cmsTagMap[tag.contentType].push({
        identifier: tag.identifier,
        conditions: tag.conditions
      });
    } else {
      const existingTag = cmsTagMap[tag.contentType].find((t) => t.identifier === tag.identifier);
      if (existingTag) {
        if ((existingTag.conditions?.length || 0) > (tag.conditions?.length || 0)) {
          existingTag.conditions = tag.conditions;
        }
      }
    }
  }
  return cmsTagMap;
};
export {
  findAllCmsTags
};
